export enum CollectionSortField {
	name = 'name',
	numberOfPuzzles = 'numberOfPuzzles',
}
